// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3KWoz","logo":"Navbar_logo__gT4EI","visible":"Navbar_visible__3tS6e","hidden":"Navbar_hidden__3hzAT"};